import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';

const CreateNegotiation = gql`
  mutation CreateNegotiation($input: CreateNegotiationInput!) {
    createNegotiation(createNegotiationInput: $input) {
      _id
      createdAt
      status
    }
  }
`;

const UpdateNegotiation = gql`
  mutation UpdateNegotiation($id: String!, $input: UpdateNegotiationInput!) {
    updateNegotiation(id: $id, updateNegotiationInput: $input) {
      _id
      createdAt
      updatedAt
      user_id
      lot_id
      status
    }
  }
`;

const RevokeNegotiation = gql`
  mutation RemoveNegotiation($id: String!) {
    removeNegotiation(id: $id) {
      _id
      updatedAt
      status
    }
  }
`;

const CreateContract = gql`
  mutation CreateContractType($input: CreateContractInput!) {
    createContract(createContractInput: $input) {
      _id
      createdAt
      updatedAt
      buyer_id
      seller_id
      lot_id
      negotiation_id
      lot_type
      # contract_type
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class NegotiationActionsService {
  constructor(private apollo: Apollo) {}

  acceptNegotiation() {
    // logic for accepting negotiation and makeing contract
  }

  createNegotiation(createNegotiationInput) {
    return this.apollo.mutate({
      mutation: CreateNegotiation,
      variables: {
        input: createNegotiationInput,
      },
    });
  }

  updateNegotiation(negotiationId: string, dataInput) {
    // console.log('id: ', negotiationId);
    // console.log('data input: ', dataInput);
    return this.apollo.mutate({
      mutation: UpdateNegotiation,
      variables: {
        id: negotiationId,
        input: dataInput,
      },
    });
  }

  createContract(createContractInput) {
    return this.apollo.mutate({
      mutation: CreateContract,
      variables: {
        input: createContractInput,
      },
    });
  }

  revoke(negotiationId: string) {
    return this.apollo.mutate({
      mutation: RevokeNegotiation,
      variables: {
        id: negotiationId,
      },
    });
  }
}
